/** Created by manoraj.k on 17/08/17. */
import styled from 'styled-components';
import { colors } from '../../colorCodes';

export const ToggleComponentContainer = styled.div`
    position: relative;
    display: inline-block;
    font-size: 12px;
    color: ${colors.greyText};
    .toggle-button {
        position: relative;
        border: solid 1px ${colors.greyBorder};
        padding: 6px 36px 6px 12px;
        border-radius: 4px;
        cursor: pointer;
    }
     .disabled {
        color: ${colors.greyBorder};
    }
    .active {
        color: ${colors.brandBlue};
    }
    .toggle-button-close {
        border: none;
    }
    .toggle-container {
        position: absolute;
        top: 0px;
        left: 0px;
        background: ${colors.whiteText};
        border: solid 1px ${colors.greyBorder};
        border-radius: 4px;
        z-index: 1;
    }
    .show {
        display: block;
    }
    .hide {
        display: none;
    }
    .toggle-icon {
        position: absolute;
        right: 12px;
        top: 7px;
    }
    .has-filter {
        border-color: ${colors.brandBlue};
    }
    .active-icon-color {
        color: ${colors.brandBlue};
    }
    .inprogress-icon-color {
        color: ${colors.inprogressIcon};
    }
`;
export const ResetButton = styled.i`
    border-right: 1px solid ${colors.inputBorder};
    padding-right: 10px;
    margin-right: 8px;
`;
